module.exports = __webpack_public_path__ + "static/media/emergency_header.55d5ddc0.svg";